module.exports = (__webpack_require__(0))(24);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-router/getCurrentRouteState.js from dll-reference rlink_core
// module id = 34
// module chunks = 0